import React from 'react';
import {FormInput} from 'react-form';

export default ( { field, ...rest } ) => {
  return (
    <FormInput field={field}>
      {( { setValue, getValue, setTouched } ) =>
        <textarea
          {...rest}
          value={getValue() || ''}
          onChange={val => setValue( val.target.value )}
          onBlur={() => setTouched()}
        />
      }
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/Textarea/index.js